#import "~/graphql/fragments/User.graphql"

mutation (
    $email: String!
    $token: String!
) {
    loginStep2(
        email: $email
        token: $token
    ) {
        status
        message

        user {
            ...User
        }
    }
}
